import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyTable } from 'src/components/utils/EmtpyTable';
import { IAssetYearlyTaxReports } from 'src/models/index';
import { SingleYearlyTaxReport } from './yearlyTaxReports/SingleYearlyTaxReport';
import { YearlyReportsTable } from './yearlyTaxReports/YearlyReportsTable';

interface Props {
  editTaxReport: (taxReportIndex: number) => void;
  yearlyTaxReports?: IAssetYearlyTaxReports[];
}

export const YearlyTaxReport: FC<Props> = ({ editTaxReport, yearlyTaxReports }) => {
  const { t } = useTranslation();
  return (
    <YearlyReportsTable emptyElement={<EmptyTable bottomText={t('asset.yearlyTaxReport.table.noReport')} />}>
      {yearlyTaxReports?.map((yearlyTaxReport: IAssetYearlyTaxReports, index: number) => (
        <SingleYearlyTaxReport yearlyTaxReport={yearlyTaxReport} index={index} editTaxReport={editTaxReport} key={index} />
      ))}
    </YearlyReportsTable>
  );
};
